import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import get from 'lodash/get';
import hasIn from 'lodash/hasIn';
import { Marker, InfoWindow } from 'react-google-maps';
import stylesMarker from './ProductTableStyle.scss';
import cx from 'classnames';

const parentElementSelector = 'parentElement.parentElement.parentElement.parentElement';

export default class SearchMapMarker extends Component {
  markerInitCyclesLeft = 10;
  markerInitTimeout = 300;

  isMarkerExpanded() {
    return this.props.id === this.props.expandedId;
  }

  changeMarkerClassName = () => {
    if (this.ref) {
      if (!hasIn(this.ref, parentElementSelector)) {
        if (this.markerInitCyclesLeft > 0) {
          this.markerInitCyclesLeft && setTimeout(this.changeMarkerClassName, this.markerInitTimeout);
          this.markerInitCyclesLeft--;
        }
        return;
      }
      const className = cx(stylesMarker.marker, {
        [stylesMarker.markerSmall]: !this.isMarkerExpanded(),
        [stylesMarker.markerExpanded]: this.isMarkerExpanded(),
        [stylesMarker.markerChosenPVZ]: this.props.isChosenPVZ && !this.isMarkerExpanded(),
      });
      get(this.ref, parentElementSelector, {}).className = className;
    }
  };

  onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.expandMarker(this.props.id);
  };

  collapseMarker = (e) => {
    e.stopPropagation();
    this.props.collapseMarker(null);
  };

  onPartnerSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const partnerId = e.target.getAttribute('data-partnerid');
    const detailNum = this.props.searchQuery;
    this.props.submitSearch(detailNum, partnerId);
    this.props.collapseMarker(null)
  };

  initMarker = (ref) => {
    this.ref = ref;
    this.changeMarkerClassName();
  };

  render() {
    if (!this.props.price) {
      return null;
    }

    this.changeMarkerClassName();
    const {
      price, address, searchByPartnerId, partnerId, collapseMarker,
      companyName = 'ООО "ТВЦ"', phoneNumber = '+7 (383) 299-40-22',
      workingDays = 'Пн-Пт 09:00-19:30\nСб 10:00-14:30',
    } = this.props;

    const infoWindowContent = this.isMarkerExpanded() ? (
      <div className={cx(stylesMarker.expandedMarkerContent, 'align-left')}>
        <div onClick={this.collapseMarker} className={stylesMarker.closeBtn} />
        <p className="m-b-0_5">{companyName}</p>
        <p className="m-b-0_5">{address}</p>
        <p className="m-b-0_5">{phoneNumber}</p>
        <p className="m-b-0_5">{workingDays}</p>
        <button
          data-partnerid={partnerId}
          onClick={this.onPartnerSearch.bind(this)}
          className="btn-brand w-100"
        >
          Выбрать этого партнера
        </button>
      </div>
      ) : <p>{price}</p>;
    //) : (!!this.props.price ? this.props.price : '');

    return (
      <Marker {...this.props}>
        <InfoWindow>
          <div
            onClick={this.onClick}
            ref={this.initMarker}
          >
            {infoWindowContent}
          </div>
        </InfoWindow>
      </Marker>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchResults/elements/SearchMapMarker.jsx
 **/